import { render, staticRenderFns } from "./AddressTypeSetting.vue?vue&type=template&id=2b52cc7c"
import script from "./AddressTypeSetting.vue?vue&type=script&lang=js"
export * from "./AddressTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports